export { Tag } from './Tag';
export type { Props } from './Tag.types';
